import { AlertCircle } from 'lucide-react'
import { Button, LinkButton } from '@react-spectrum/s2'

export function NotFound() {
  return (
    <div className="flex min-h-[calc(100vh-80px)] flex-col items-center justify-center bg-neutral-50 dark:bg-neutral-950 p-4 text-center font-sans">
      <div className="mb-4 rounded-full bg-red-100 p-4 text-red-600 dark:bg-red-900/30 dark:text-red-400">
        <AlertCircle className="h-12 w-12" />
      </div>
      <h1 className="mb-2 text-4xl font-bold text-neutral-900 dark:text-neutral-100">
        Page Not Found
      </h1>
      <p className="mb-8 max-w-md text-neutral-500 dark:text-neutral-400">
        Sorry, we couldn't find the page you're looking for. It might have been
        moved, deleted, or never existed.
      </p>
      <div className="flex gap-4">
        <LinkButton href="/">Go home</LinkButton>
        <Button
          variant="secondary"
          fillStyle="outline"
          onPress={() => window.history.back()}
        >
          Go back
        </Button>
      </div>
    </div>
  )
}
